const { invoiceStatusV1List } = require('./invoice');

const InvoiceLabelStatusMapping = invoiceStatusV1List.reduce((acc, status) => {
  acc[status.invoice_label] = status.id;
  return acc;
}, {});

const invoiceMapping = {
  100: [1, 2, 3, 4],
  101: [5, 6],
  102: [6, 7, 8],
  103: [8, 9],
};

const fetchVoucher = [3, 7, 8, 9, 10, 11, 12];

const groupMapping = { // Payment status level
  pending: [1, 2],
  re_submitted: [13],
  rejected: [4],
  accepted: [3],
  processing: [5, 6, 7, 8, 9, 10, 12],
  paid: [11],
};

let approvedStatusList = [];
Array.prototype.push.apply(approvedStatusList, groupMapping.accepted);
Array.prototype.push.apply(approvedStatusList, groupMapping.processing);
Array.prototype.push.apply(approvedStatusList, groupMapping.paid);

const upload_posted_payments = {
  'alt reference number': 'reference_number',
  'document number': 'doc_number',
  'posting date': 'posting_date',
};

const upload_paid_payment = {
  'document number': 'doc_number',
  'clearing date': 'clearance_date',
  'clearing Document': 'clearance_doc_no',
  text: 'reference_number',
};


const typeMapping = [
  {
    type: 1,
    name: 'approved_invoice',
    status_mapping: [
      {
        approve: 'librarian_accepted',
      },
      {
        reject: 'librarian_rejected',
      },
    ],
  },
  {
    type: 2,
    name: 'approved_payment',
    status_mapping: [
      {
        approve: 'payment_accepted',
      },
      {
        reject: 'payment_rejected',
      },
    ],
  },
];

const paymentColumns = {
  aggrigate: [
    'contract_charge', 'lr_charge',
    'loading_charge', 'loading_detention_charge', 'unloading_charge',
    'unloading_detention_charge', 'oda_charges', 'additional_point_charges',
    'extra_charges',
  ],
  dedutions: [
    'transit_charge', 'shortage_charge', 'damage_charge', 'leakage_charge', 'arrival_charge', 'wallet_penalty_charge', 'carton_damage_charge',
  ],
};

module.exports = {
  invoiceMapping,
  groupMapping,
  fetchVoucher,
  upload_posted_payments,
  upload_paid_payment,
  paymentColumns,
  approvedStatusList,
  InvoiceLabelStatusMapping,
};
